module.exports = __webpack_public_path__ + "images/emoji/palm_tree.e7f8b0ac8ded83a1ee5a.png";